import fetch, { parseResponse } from "./fetch";

class Import {
    importSource() {
        return fetch.get(`import/source/front`);
    }

    importFamilleSecteur() {
        return fetch.get(`import/famille_secteur/front`);
    }

    importAnneeSecteur() {
        return fetch.get(`import/annee_secteur/front`);
    }

    importField() {
        return fetch.get(`import/field/front`);
    }

    importProduit() {
        return fetch.get(`import/produit/front`);
    }

    export(params?: HashMap<any>) {
        return parseResponse(fetch.post(`export/fromImport`, params));
    }
}

export default new Import();
